module.exports = __webpack_public_path__ + "img/test-online-bg.c2b73777.jpg";